// extracted by mini-css-extract-plugin
export default {"contentOverImage":"PlayNow_contentOverImage__FmZA8","logoOverImage":"PlayNow_logoOverImage__UNB97","divider":"PlayNow_divider__aEYOL"};